<template>
  <h3 v-if="title" class="option-group-title">{{ title }}</h3>
</template>

<script>
export default {
  name: 'OptionGroupHeader',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.option-group-title {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-color);
  margin: 0;
  padding: 15px 20px 0;
}
</style>
